import _ from 'lodash';
import { enums } from 'console-kit';

import RefData from 'ref-data';

/**
 * defines the integration types that should open up in the Integration Designer
 */
const designerIntegrationSupport = [
  RefData.Enum.TYPE.INTEGRATION.HTTP,
  RefData.Enum.TYPE.INTEGRATION.SAILTHRU,
  RefData.Enum.TYPE.INTEGRATION.SAILTHRUSELFSERVE,
  RefData.Enum.TYPE.INTEGRATION.CHEETAH_EDP,
  RefData.Enum.TYPE.INTEGRATION.CHEETAH_MESSAGING,
  RefData.Enum.TYPE.INTEGRATION.SELLIGENT,
  RefData.Enum.TYPE.INTEGRATION.EMMA,
  RefData.Enum.TYPE.INTEGRATION.CAMPAIGNMONITOR,
  RefData.Enum.TYPE.INTEGRATION.ONLOADHTTP,
  RefData.Enum.TYPE.INTEGRATION.OPENIDONLOAD,
  RefData.Enum.TYPE.INTEGRATION.PESPROFILE,
  RefData.Enum.TYPE.INTEGRATION.SNOWFLAKE,
  RefData.Enum.TYPE.INTEGRATION.ZMPONLOAD,
];

const wizardIntegrationSupport = [
  RefData.Enum.TYPE.INTEGRATION.EMMA,
  RefData.Enum.TYPE.INTEGRATION.CAMPAIGNMONITOR,
  RefData.Enum.TYPE.INTEGRATION.SAILTHRUSELFSERVE,
  RefData.Enum.TYPE.INTEGRATION.PESPROFILE,
  RefData.Enum.TYPE.INTEGRATION.OPENIDONLOAD,
  RefData.Enum.TYPE.INTEGRATION.ZMPONLOAD,
];

const wizardIntegrationsWithoutCredentials = [RefData.Enum.TYPE.INTEGRATION.PESPROFILE];

const integrationDesignerMappingData = {
  FORM_DATA:            'formData',
  EXPERIENCE_META_DATA: 'experienceMetaData',
  OTHER_DATA:           'otherData',
};
integrationDesignerMappingData.ALL = _.values(integrationDesignerMappingData);

const integrationParamsTypes = {
  ALL_MAPPED: 'all', //a value used to tell us that the integration will use both mapped params and the experience specific ones
  MAPPED:     'mapped', //it will use ONLY mapped params and no other - DEFAULT VALUE!
};
integrationParamsTypes.ALL = _.values(integrationParamsTypes);

/**
 * Array of restricted integration template types
 */

const RESTRICTED_INTEGRATION_TEMPLATES = [
  RefData.Enum.TYPE.INTEGRATION.HTTP,
  RefData.Enum.TYPE.INTEGRATION.SAILTHRU,
  RefData.Enum.TYPE.INTEGRATION.SAILTHRUSELFSERVE,
  RefData.Enum.TYPE.INTEGRATION.CHEETAH_EDP,
  RefData.Enum.TYPE.INTEGRATION.CHEETAH_MESSAGING,
  RefData.Enum.TYPE.INTEGRATION.SELLIGENT,
  RefData.Enum.TYPE.INTEGRATION.SNOWFLAKE,
];

const integrationFieldTypes = {
  MULTISELECT: 'multiselect',
  SELECT:      'select',
  CHECKBOX:    'checkbox',
  TEXTAREA:    'textarea',
  TEXT:        'text',
  PASSWORD:    'password',

  // custom types
  SCRIPT:        'script',
  SECRET:        'secret',
  REMOTE_FIELDS: 'remotefields',
};

const integrationWizardStepTypes = {
  FORM:    'form',
  MAPPING: 'mapping',
};

const integrationWizardMappingDirections = {
  FROM: 'from',
  TO:   'to',
};

const campaignDataSource = [
  { id: 'campaign', name: 'Campaign', disabled: true },
  { id: 'campaign.id', name: 'Campaign ID', indent: enums.sizes.SMALL },
  { id: 'campaign.name', name: 'Campaign name', indent: enums.sizes.SMALL },
  { id: 'campaign.externalRef', name: 'ExternalRef', indent: enums.sizes.SMALL },
];

const accountDataSource = [
  { id: 'account', name: 'Account', disabled: true },
  { id: 'account.id', name: 'Account ID', indent: enums.sizes.SMALL },
  { id: 'account.name', name: 'Account name', indent: enums.sizes.SMALL },
];

const dataTypes = {
  STRING:     'string',
  BOOLEAN:    'boolean',
  DATE:       'date',
  DATETIME:   'datetime',
  SCRIPT:     'script',
  ARRAY:      'array',
  OBJECT:     'object',
  EXPRESSION: 'expression',
};

// Question: Why do we use specific strings and not REFs ?
// Answer: Because the ref tends to differ but behind the scenes
// they use the same image, this allows us to just target the image
// path, and specifically alter it to white inside the picker
const INVERTED_INTEGRATION_LOGOS = [
  'integration_adobecommerce.svg',
  'integration_messaging_cheetah.svg',
  'integration_selligent.svg',
  'integration_edp.svg',
  'integration_sailthru.svg',
  'integration_zmp.svg',

  // 'integration_campaign_monitor.svg',
  // 'integration_emma.svg',
];

const EXPERIENCE_BASED_INTEGRATIONS = [
  RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZADOBECOMMERCE,
  RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZSHOPIFY,
];

const REQUIRED_FLAG_FIELD = 'required';

const wizardMappingRequiredFlagConfig = {
  name:    'Required',
  tooltip: 'If a field is marked as Required, the entry data will only be sent if that field is populated',
  field:   REQUIRED_FLAG_FIELD,
};

export default {
  designerIntegrationSupport,
  wizardIntegrationSupport,
  wizardIntegrationsWithoutCredentials,
  integrationParamsTypes,
  RESTRICTED_INTEGRATION_TEMPLATES,
  integrationDesignerMappingData,
  integrationFieldTypes,
  integrationWizardStepTypes,
  integrationWizardMappingDirections,
  campaignDataSource,
  accountDataSource,
  dataTypes,
  INVERTED_INTEGRATION_LOGOS,
  EXPERIENCE_BASED_INTEGRATIONS,
  REQUIRED_FLAG_FIELD,
  wizardMappingRequiredFlagConfig,
};
